import React, { useEffect, useState } from "react";
import YoutubeIcon from "../../../../assets/images/youtube.png";
import DeleteSelectedScreenshot from "../modals/DeleteSelectedScreenshot";
import ViewPicture from "../modals/ViewPicture";
import { useHistory } from "react-router";
import useKidListFunctionality from "../../../customHooks/kidListHook";
import { useDispatch, useSelector } from "react-redux";
import useLangTranslation from "../../../customHooks/languageProvider";
import CommonStatus from "../Common/CommonStatus";
import useDeviceStatus from "../../../customHooks/deviceStatusProvider";
import {
  formattedDateTime,
  formattedDateTimev2,
  handleStartDate,
  handleStartDateCommon,
} from "../../../../utils/helper";
import moment from "moment";
import {
  blockUnblockYouTubeData,
  deleteYouTubeData,
  getCountYouTubeData,
  getYouTubeData,
} from "../../AxiosRtk/YouTube/YOUTUBECURD";
import ViewVideo from "../modals/ViewVideo";
import { isEmpty } from "lodash";
import { setShowMessage } from "../../AxiosRtk/successMessage";
import BlockUnblockYouTube from "../modals/BlockUnblockYouTube";
import useDurationOption from "../../../customHooks/durationOption";
import Select from "react-select";
import LoadingIndicator from "../../../../setup/Loader/LoaderIndicator";
import { constant } from "../../../../utils/constant";
import DateFilter from "../../../shared/DateFilter/DateFilter";
import { useDashboardDataProvider } from "../../../customHooks/dashboardDataProvider";
import axios from "axios";

const YoutubeSummary = () => {
  const dispatch = useDispatch();
  const { durationOptionsFunction } = useDurationOption();
  const { handleDeviceSelection } = useDashboardDataProvider();
  const [loading, setLoading] = useState(false); // Track if action is in progress

  const [deviceOptions, setDeviceOptions] = useState([]);
  const [selectedDuration, setSelectedDuration] = useState(1);
  const durationOptions = durationOptionsFunction();
  const history = useHistory();
  const { getImage } = useKidListFunctionality();
  const { kidDevicesList, kidList, selectedKidId, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);
  const { getLangTranslation } = useLangTranslation();
  const [startDate, setStartDate] = useState(
    moment().startOf("day").format("YYYY-MM-DD HH:mm:ss")
  );
  const [viewVideoModal, setViewVideoModal] = useState(false);

  const initialEndDate = moment().locale("en").format("YYYY-MM-DD HH:mm:ss");
  const [endDate, setEndDate] = useState(initialEndDate);

  const handleGoBack = () => {
    history.goBack();
  };
  const [videoCount, setVideoCount] = useState(null);
  const [selectedItem, setSelectedItem] = useState({});
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [selectedScreenshots, setSelectedScreenshots] = useState([]);
  const [screenshotListData, setScreenshotListData] = useState([]);
  const [itemToBlockUnblock, setItemToBlockUnblock] = useState(null); // Track selected item for block/unblock

  const [kidData, setKidData] = useState(false);
  const [deviceStatus, setDeviceStatus] = useState("");
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );
  const [deletedSelectedModal, setDeletedSelectedModal] = useState(false);
  const [viewPictureModal, setViewPictureModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const openDeletedSelected = () => {
    setDeletedSelectedModal(true);
  };
  const closeDeletedSelected = () => {
    setDeletedSelectedModal(false);
  };
  const openViewPicture = () => {
    setViewPictureModal(true);
  };
  const closeViewPicture = () => {
    setViewPictureModal(false);
  };
  // const handleDeviceChange = (value) => {
  //   setSelectedDeviceId(value);
  // };
  const handleSelectAllChange = (e) => {
    const { checked } = e.target;
    setIsSelectAll(checked ? 1 : 0);
    // if (selectedScreenshots.length === screenshotListData.length) {
    //   setSelectedScreenshots([]);
    // } else {
    //   setSelectedScreenshots(screenshotListData.map((item) => item.nudityId));
    // }
  };

  const handleAllowBlock = async (blockStatus = 0) => {
    //   if (itemToBlockUnblock) {
    //     const payload = {
    //       deviceId: selectedDeviceData?.ID,
    //       isBlock: itemToBlockUnblock?.isBlock === 0 ? 1 : 0, // Toggle block status
    //       activityId: itemToBlockUnblock?.ID,
    //     };

    //     try {
    //       const { data } = await blockUnblockYouTubeData(payload);
    //       if (data) {
    //         dispatch(
    //           setShowMessage({
    //             showMessage: true,
    //             defaultMessage: data?.message,
    //             message: data?.message,
    //           })
    //         );
    //         // closeDeletedSelected();
    //         setSelectedScreenshots([]);
    //         getYouTubeHistory();
    //       }
    //     } catch (error) {

    //       closeBlockModal();
    //       console.log(error);
    //     }
    //   }
    if (loading || !itemToBlockUnblock) return; // Prevent duplicate actions
    setLoading(true); // Mark as loading
    const payload = {
      deviceId: selectedDeviceData?.ID,
      isBlock: itemToBlockUnblock?.isBlock === 1 ? 0 : 1, // Toggle block/unblock
      activityId: itemToBlockUnblock?.ID,
    };

    try {
      const { data } = await blockUnblockYouTubeData(payload);
      if (data) {
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: data?.message,
            message: data?.message,
          })
        );
        await getYouTubeHistory(); // Refresh the data
      }
    } catch (error) {
      console.error("Error during block/unblock:", error);
    } finally {
      setLoading(false); // Reset loading state
      closeBlockModal(); // Close modal and reset `itemToBlockUnblock`
    }
  };

  function getYouTubeHistory() {
    if (selectedDeviceData && startDate) {
      const filterDate = moment(startDate)
        .locale("en")
        .format("YYYY-MM-DD HH:mm:ss");
      const obj = {
        kidId: selectedKidId,
        deviceId: selectedDeviceData?.ID,
        activityType: "VIDEO_LINKS",
        startDate: filterDate,
        endDate: endDate,
        pageNo: 1,
        itemsPerPage: 20000,
      };
      setLoader(true);
      getYouTubeData(obj)
        .then((res) => {
          setScreenshotListData(res?.data?.result);
          // setScreenshotListData([
          //   {
          //     ID: 44971,
          //     deviceId: 12131,
          //     videoUrl: "hello",
          //     videoThumbnail: "",
          //     duration: "2024-03-04T13:45:10.000Z",
          //     isGalleryVideo: 0,
          //     activityStatus: 0,
          //     isBadWord: 2,
          //     isKeyStroke: 0,
          //     exactBadWord: "hello",
          //     type: "VIDEO_LINKS",
          //     DateCreated: "2024-03-04T08:17:32.000Z",
          //     videoTitle: "",
          //     isBlock: null,
          //   },
          //   {
          //     ID: 44930,
          //     deviceId: 12131,
          //     videoUrl: "hello",
          //     videoThumbnail: "",
          //     duration: "2024-03-01T19:26:14.000Z",
          //     isGalleryVideo: 0,
          //     activityStatus: 0,
          //     isBadWord: 2,
          //     isKeyStroke: 0,
          //     exactBadWord: "hello",
          //     type: "VIDEO_LINKS",
          //     DateCreated: "2024-03-01T13:56:30.000Z",
          //     videoTitle: "",
          //     isBlock: null,
          //   },
          // ]);
        })
        .catch((err) => {
          console.log("rating catch error ==>>", err?.response?.data?.message);
        })
        .finally(() => {
          setLoader(false);
        });
    }
  }

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  function getYouTubeDataCount() {
    if (selectedDeviceData && startDate) {
      const filterDate = moment(startDate)
        .locale("en")
        .format("YYYY-MM-DD HH:mm:ss");
      const obj = {
        // kidId: selectedKidId,
        deviceId: selectedDeviceData?.ID,
        // activityType: "VIDEO_LINKS",
        startDate: startDate,
        endDate: endDate,
      };
      getCountYouTubeData(obj)
        .then((res) => {
          // if (res?.data?.success) {
          setVideoCount(res?.data?.result);
          // }
        })
        .catch((err) => {
          console.log("rating catch error ==>>", err?.response?.data?.message);
        });
    }
  }

  const handleDelete = async (type) => {
    if (!isEmpty(selectedScreenshots) || isSelectAll) {
      const payload = {
        deviceId: selectedDeviceData?.ID,
        isDeleteAll: 0,
        activityType: "VIDEO_LINKS",
        videoActivityId: selectedScreenshots.toString(),
        type: type,
      };

      try {
        const { data } = await deleteYouTubeData(payload);
        if (data) {
          // dispatch(
          //   setShowMessage({
          //     showMessage: true,
          //     defaultMessage: data?.message,
          //     message: data?.message,
          //   })
          // );
          setTimeout(() => {
            dispatch(
              setShowMessage({
                showMessage: true,
                defaultMessage: data?.message,
                message: data?.message,
              })
            );
          }, 800);
          closeDeletedSelected();
          setSelectedScreenshots([]);
          getYouTubeHistory();
        }
      } catch (error) {
        closeDeletedSelected();
        console.log(error);
      }
    }
  };

  const handleCheckboxChange = (galleryId) => {
    if (selectedScreenshots.includes(galleryId)) {
      setSelectedScreenshots(
        selectedScreenshots.filter((id) => id !== galleryId)
      );
    } else {
      setSelectedScreenshots([...selectedScreenshots, galleryId]);
    }
  };
  const openViewVideo = (item) => {
    const screenshotUrl = item?.imageUrl;
    setSelectedItem(screenshotUrl);

    setViewVideoModal(true);
  };

  const closeViewVideo = () => {
    setViewVideoModal(false);
  };

  const openBlockModal = (item) => {
    if (!loading) {
      setItemToBlockUnblock(item); // Set the item to block/unblock
      setShowBlockModal(true);
    }
  };
  const closeBlockModal = () => {
    setShowBlockModal(false);
    setItemToBlockUnblock(null);
  };

  useEffect(() => {
    getYouTubeHistory();
    getYouTubeDataCount();
  }, [startDate, selectedDeviceData, endDate]);

  useEffect(() => {
    setKidData(kidList?.find((item, index) => item.ID == selectedKidId));
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (selectedDeviceData) {
      getDeviceStatusData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData]);

  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  function getThumbnailFromVideoUrl(url) {
    if (!url) return "";
    const match =
      url.match(/(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^&]+)/) ||
      url.match(/(?:https?:\/\/)?youtu\.be\/([^?&]+)/);

    const videoId = match ? match[1] : null;

    if (!videoId) return "";

    const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    return thumbnailUrl;
  }

  return (
    <>
      <BlockUnblockYouTube
        showModal={showBlockModal}
        closeModal={closeBlockModal}
        handleSubmit={() => {
          handleAllowBlock();
        }}
      />
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <div
                    className="text-blue-900 fs-5 cursor-pointer"
                    onClick={handleGoBack}
                  >
                    <i
                      className={`${lang?.isRTL === 1
                        ? "icon-arrow-right"
                        : "icon-arrow-left"
                        }`}
                    />
                  </div>
                  <h3 className="text-blue-900 mb-0">
                    {getLangTranslation(
                      "YOUTUBE_MONITORING_TITLE",
                      "YouTube monitoring"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <span className="icon-wrap icon-rounded me-2 p-0 overflow-hidden ratio ratio-1x1 border-0">
                {/* <img src={ChildPic} alt='' /> */}
                <img
                  src={getImage(kidData?.image, kidData?.gender)}
                  alt=""
                  className="img-fluid"
                  onError={(event) => {
                    event.target.onerror = null;
                    event.target.src = getImage("", kidData?.gender);
                  }}
                />
              </span>
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">{kidData?.childName}</h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item col-12 col-md-3">
              <div className="select-with-icon-nudity">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                {/*  <select
                  className="form-select text-dark"
                  onChange={(e) => handleDeviceChange(e.target.value)}
                  value={selectedDeviceId}
                >
                  <option value="">
                    {getLangTranslation(
                      "CHILD_DETAILS_SELECT_DEVICE",
                      "Select Device"
                    )}
                  </option>
                  {kidDevicesList?.map((device) => {
                    return (
                      <option value={device?.ID} key={device?.ID}>
                        {device?.Name}
                      </option>
                    );
                  })}
                </select>*/}
                <Select
                  className="custom-select "
                  classNamePrefix="custom-select"
                  placeholder={getLangTranslation(
                    "CHILD_DETAILS_SELECT_DEVICE",
                    "Select Device"
                  )}
                  options={deviceOptions}
                  value={
                    deviceOptions?.find(
                      (item) => item?.value == selectedDeviceData?.ID
                    ) || ""
                  }
                  onChange={handleDeviceSelection}
                  isSearchable={false}
                />
              </div>
            </div>
            <div className="d-flex gap-3 justify-content-end flex-fill">
              <div className="d-flex justify-content-center  align-items-center rounded-3 content-150 w-100 p-6 bg-gray-800 gap-3">
                <h3 className="mb-0 text-blue-900">
                  {videoCount != null ? videoCount?.fourCount : 0}
                </h3>
                <span className="text-blue-800 text-small">
                  {getLangTranslation("YOUTUBE_MONITORING_VIDEO", "Video")}
                </span>
              </div>
              <div className="d-flex justify-content-center align-items-center rounded-3 content-150 w-100 p-6 bg-gray-800 gap-3">
                <h3 className="mb-0 text-blue-900">
                  {videoCount != null
                    ? videoCount?.zeroCount +
                    videoCount?.oneCount +
                    videoCount?.threeCount +
                    videoCount?.twoCount
                    : 0}
                </h3>
                <span className="text-blue-800 text-small">
                  {getLangTranslation("YOUTUBE_MONITORING_SEARCH", "Search")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-6 mb-6">
            <div className="d-flex align-items-center flex-wrap gap-6">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  name="allSelect"
                  id="selectAll"
                  checked={isSelectAll}
                  onChange={handleSelectAllChange}
                />
                <label
                  className="form-check-label text-dark"
                  htmlFor="selectAll"
                >
                  {getLangTranslation(
                    "YOUTUBE_MONITORING_SEELECT_ALL_BUTTON",
                    "Select all"
                  )}
                </label>
              </div>
              <button
                className="btn btn-outline-primary"
                type="button"
                onClick={openDeletedSelected}
              >
                {getLangTranslation(
                  "YOUTUBE_MONITORING_DELETE_SELECTED_BUTTON",
                  "Delete selected"
                )}
              </button>
              {/* <button
                className="btn btn-outline-success d-inline-flex align-items-center gap-1 text-nowrap"
                onClick={() => handleAllowBlock(0)}
              >
                <i className="icon-check-fill success-icon fs-5" />{" "}
                {getLangTranslation("YOUTUBE_MONITORING_ALLOW_BUTTON", "Allow")}
              </button> */}
              {/* <button
                className="btn btn-outline-danger d-inline-flex align-items-center gap-1 text-nowrap"
                onClick={() => {
                  if (selectedScreenshots.length > 0) openBlockModal();
                }}
              >
                <i className="icon-ban danger-icon fs-5" />{" "}
                {getLangTranslation("YOUTUBE_MONITORING_BLOCK_BUTTON", "Block")}
              </button> */}
            </div>
            <div className="d-flex align-items-center gap-3 justify-content-end flex-fill">
              {/* <select
                className="form-select content-200 text-dark"
                id="country"
                aria-label="Default select example"
                name="gender"
                onChange={(event) => handleStartDate(event, setStartDate)}
              >
                <option value="1">Today</option>
                <option value="2">1 Week</option>
                <option value="3">2 Week</option>
                <option value="4">1 Month</option>
                <option value="5">All</option>
              </select>*/}
              <DateFilter
                startDate={startDate}
                endDate={endDate}
                setEndDate={setEndDate}
                setStartDate={setStartDate}
                selectedDuration={selectedDuration}
              />
              <Select
                className="custom-select col-sm-3"
                classNamePrefix="custom-select"
                placeholder="Select"
                onChange={(val) => {
                  handleStartDateCommon(
                    val,
                    setStartDate,
                    setSelectedDuration,
                    setEndDate
                  );
                }}
                options={durationOptions}
                value={
                  durationOptions?.find(
                    (item) => item?.value == selectedDuration
                  ) || ""
                }
              />
            </div>
          </div>
          <div>
            {screenshotListData?.map((item, index) => {
              // console.log(item);
              const isUTubeLink = item?.videoUrl?.startsWith("m.youtube.com");
              return (
                // item.videoThumbnail ? (
                //   // Render grid layout if videoThumbnail is not empty
                //   <div className="grid gap-6" key={index}>
                //     <div className="g-col-12 g-col-md-6 g-col-lg-4">
                //       <div className="ratio ratio-5x3 mb-3">
                //         <video
                //           className="rounded-3 cursor-pointer"
                //           src={item?.videoUrl}
                //           alt="Image"
                //           onClick={() => openViewVideo(item)}
                //         />
                //         <input
                //           className="form-check-input top-0 start-100 mt-3"
                //           style={{ marginLeft: "-2rem" }}
                //           type="checkbox"
                //           id={`checkbox-${index}`}
                //           checked={selectedScreenshots.includes(item.ID)}
                //           onChange={() => handleCheckboxChange(item.ID)}
                //         />
                //         <i className="icon-play top-50 start-50 translate-middle w-auto h-auto display-5 pt-cursor text-white opacity-75" />
                //       </div>
                //       <div className="d-flex align-items-center gap-3 mb-3">
                //         <span className={`text-small ${lang?.isRTL === 1 ? "ms-auto" : "me-auto"}`}>
                //           {formattedDateTime(item?.DateCreated)}
                //         </span>
                //         {item?.isBlock == 0 ? (
                //           <>
                //             <i className="icon-check-fill fs-5 text-success border rounded-circle border-success" />
                //             <i className="icon-ban fs-5 text-blue-50 border rounded-circle" />
                //           </>
                //         ) : (
                //           <>
                //             <i className="icon-check-fill fs-5 text-blue-50 border rounded-circle" />
                //             <i className="icon-ban fs-5 text-danger border rounded-circle border-danger" />
                //           </>
                //         )}
                //       </div>
                //       <div className="d-flex align-items-center gap-3">
                //         <div className="icon-wrap border-0 flex-shrink-0">
                //           <img src={YoutubeIcon} alt="" width="30" />
                //         </div>
                //         <div className="d-flex flex-column">
                //           <span className="text-blue-900 fw-semibold text-small">
                //             {item?.videoTitle}
                //           </span>
                //           <span className="text-small line-clamp">
                //             {item?.videoUrl}
                //           </span>
                //         </div>
                //       </div>
                //     </div>
                //   </div>
                // ) : (
                // Render list layout if videoThumbnail is empty
                <div className="list-group" key={item?.ID}>
                  <div className="list-group-item mb-4">
                    <div className="d-flex align-items-start gap-3">
                      <div className="me-3 position-relative">
                        <video
                          className="rounded-3 cursor-pointer"
                          src={item?.videoUrl}
                          alt="Image"
                          style={{ width: "2rem" }}
                          onClick={() => openViewVideo(item)}
                        />
                        <input
                          className="form-check-input position-absolute mt-3"
                          style={{ marginLeft: "-2rem" }}
                          type="checkbox"
                          id={`checkbox-${index}`}
                          checked={selectedScreenshots.includes(item.ID)}
                          onChange={() => handleCheckboxChange(item.ID)}
                        />
                      </div>
                      <div className="d-flex w-100">
                        <div className="utube-thumbnail border-0 flex-shrink-0 mx-2">
                          <img
                            src={getThumbnailFromVideoUrl(item?.videoUrl)}
                            alt="video thumbnail"
                            width={100}
                            onError={(event) => {
                              event.target.onerror = null;
                              event.target.src =
                                "https://via.placeholder.com/480x360?text=No+Thumbnail";
                            }}
                          />
                        </div>
                        <div className="flex-grow-1">
                          <div className="mb-2">
                            <span
                              className={`text-small d-inline-block ${lang?.isRTL === 1 ? "ms-auto" : "me-auto"
                                }`}
                            >
                              {formattedDateTimev2(item?.duration)}
                            </span>
                          </div>
                          <div className="d-flex align-items-start gap-2">
                            <div className="flex-shrink-0">
                              <img
                                src={YoutubeIcon}
                                alt="YouTube Icon"
                                width="30"
                              />
                            </div>
                            <div>
                              {/* <h6 className="text-blue-900 fw-semibold">
                              {item?.videoTitle}
                            </h6> */}
                              {isUTubeLink ? (
                                <a
                                  href={`https://${item?.videoUrl}`}
                                  target="_blank"
                                >
                                  {item?.videoUrl}
                                </a>
                              ) : (
                                <p className="text-small line-clamp">
                                  {item?.videoUrl}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                        <div>
                          {isUTubeLink &&
                            (item?.isBlock == 1 ? (
                              <>
                                <i className={`icon-check-fill text-success border rounded-circle border-success ${loading ? "disabled" : "cursor-pointer"
                                  }`} onClick={() => openBlockModal(item)}
                                  style={{ cursor: "pointer" }} />
                                <i
                                  className={`icon-ban text-blue-50 border rounded-circle mx-2 ${loading ? "disabled" : "cursor-pointer"
                                    }`} onClick={() => openBlockModal(item)}
                                  style={{ cursor: "pointer" }}

                                />
                              </>
                            ) : (
                              <>
                                <i className={`icon-check-fill text-blue-50 border rounded-circle ${loading ? "disabled" : "cursor-pointer"
                                  }`}
                                  onClick={() => openBlockModal(item)} />
                                <i className={`icon-ban text-danger border rounded-circle border-danger mx-2 ${loading ? "disabled" : "cursor-pointer"
                                  }`}
                                  onClick={() => openBlockModal(item)}
                                  style={{ cursor: "pointer" }}

                                />
                              </>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                // )
              );
            })}
          </div>

          {!loader && screenshotListData?.length === 0 && (
            <div className="text-center my-2">
              -- {getLangTranslation("NO_DATA_LOG", "No data found")} --
            </div>
          )}

          {loader && screenshotListData?.length === 0 && (
            <LoadingIndicator
              width={100}
              height={30}
              color={constant?.color?.DODGER_BLUE}
            />
          )}
        </div>
      </div>
      <DeleteSelectedScreenshot
        selectedDeviceId={selectedDeviceData?.ID}
        selectedScreenshots={selectedScreenshots}
        showModal={deletedSelectedModal}
        closeModal={closeDeletedSelected}
        handleDelete={handleDelete}
        getLangTranslation={getLangTranslation}
        isDeleteAllSelected={isSelectAll}
      />
      <ViewPicture showModal={viewPictureModal} closeModal={closeViewPicture} />
      <ViewVideo
        showModal={viewVideoModal}
        closeModal={closeViewVideo}
        selectedItem={selectedItem}
        getLangTranslation={getLangTranslation}
      />
    </>
  );
};

export default YoutubeSummary;
